export default __webpack_public_path__ + "static/media/Group 1221.f07dae89.png";